module.exports = __webpack_public_path__ + "static/2018-year-end-report-card-image-e568c8f44f97634461b247540319070b.jpg";